// extracted by mini-css-extract-plugin
module.exports = {"SliderArrow":"styles_SliderArrow__S3BNd","arrowIcon":"styles_arrowIcon__UUzyL","black":"styles_black__uka2_"};